import { 
  statusInstructionStart,
  statusInstructionSuccess,
  statusInstructionFailure 
} from "./instructionSlice";

import { getCustom, post, put, remove } from "../../requestMethods"
import { Dispatch } from "react";

export const getInstructionsApi = () => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusInstructionStart())
    const response = await getCustom(`instruction`);
    const resData = response.data.success
    if(resData) {
      dispatch(statusInstructionSuccess(resData))
      return true
    }
  } catch (err: any) {
    const errData = err.response.data
    if(errData && err.response.status === 300) {
      const formErrors = errData.formErrors ? errData.formErrors : [errData] 
      dispatch(statusInstructionFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusInstructionFailure(errData))
      return [errData]
    }
  }
}

export const AddInstructionApi = (data: any) => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusInstructionStart())
    const response = await post(`instruction`, data);
    const resData = response.data.success
    if(resData) {
      dispatch(statusInstructionSuccess(resData))
      return true
    }
  } catch (err: any) {
    const errData = err.response.data
    if(errData && err.response.status === 300) {
      const formErrors = errData.formErrors ? errData.formErrors : [errData] 
      dispatch(statusInstructionFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusInstructionFailure(errData))
      return [errData]
    }
  }
}

export const EditInstructionApi = (instructionId: string, data: any) => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusInstructionStart())
    const response = await put(`instruction/${instructionId}`, data);
    const resData = response.data.success
    if(resData) {
      dispatch(statusInstructionSuccess(resData))
      return true
    }
  } catch (err: any) {
    const errData = err.response.data
    if(errData && err.response.status === 300) {
      const formErrors = errData.formErrors ? errData.formErrors : [errData] 
      dispatch(statusInstructionFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusInstructionFailure(errData))
      return [errData]
    }
  }
}

export const DeleteInstructionApi = (instructionId: string) => async (dispatch: Dispatch<any>) => {
  try {
    dispatch(statusInstructionStart())
    const response = await remove(`instruction/${instructionId}`);
    const resData = response.data.success
    if(resData) {
      dispatch(statusInstructionSuccess(resData))
      return true
    }
  } catch (err: any) {
    const errData = err.response.data
    if(errData && err.response.status === 300) {
      const formErrors = errData.formErrors ? errData.formErrors : [errData] 
      dispatch(statusInstructionFailure(formErrors))
      return formErrors
    } else {
      dispatch(statusInstructionFailure(errData))
      return [errData]
    }
  }
}


export const clearInstructionApi = async (dispatch: Dispatch<any>) => {
  dispatch(statusInstructionSuccess([]))
}
